import useSignal from '$actions/useSignal'

import { registerAction, triggerAction } from '$model/actions'
import { profile } from '$store/profile'

import { DEFAULT_ROUTE } from '$constants'

import useReturnTo from './useReturnTo'
import useRouter from './useRouter'

export const useLoginAttentions = () => {
  const redirect = useReturnTo()

  const { redirectWithQueryParams } = useRouter()
  const profileData = useSignal(profile)

  const data = profileData?.data?.login_attentions || []

  const isLoading = !!profileData?.loading
  const hasAttentions = !!data.length

  const resolveNow = () => {
    redirectWithQueryParams('authLoginAttentions')
  }
  const setResolvedAction = (action: VoidFunction) => {
    registerAction('at-login-attention-resolved', action)
  }
  const triggerResolvedAction = () => {
    const isTriggered = triggerAction('at-login-attention-resolved')

    if (isTriggered) return

    // Fallback
    redirect(DEFAULT_ROUTE, { replace: true })
  }

  return {
    data,
    hasAttentions,
    isLoading,
    resolveNow,
    setResolvedAction,
    triggerResolvedAction
  }
}

export default useLoginAttentions
